// TEMPLATE: Set VITE_R2_BASE_URL env var per site. Update portrait paths below for new site.
const R2_BASE = import.meta.env.VITE_R2_BASE_URL || 'https://media.thelightcall.com'

export const r2 = (path) => `${R2_BASE}/${path.replace(/ /g, '%20')}`

// Benjamin Kurtz portraits — confirmed in images/ folder
export const portraits = {
  p18: 'images/Benjamin Kurtz Portraits 2024-18.jpg',
  p20: 'images/Benjamin Kurtz Portraits 2024-20.jpg',
  p23: 'images/Benjamin Kurtz Portraits 2024-23.jpg',
  p24: 'images/Benjamin Kurtz Portraits 2024-24.jpg',
  p36: 'images/Benjamin Kurtz Portraits 2024-36.jpg',
  p37: 'images/Benjamin Kurtz Portraits 2024-37.jpg',
}
